export class ApiError extends Error {
  public statusCode?: number;
  constructor(message: string, statusCode?: number) {
    super(message)
    this.name = 'ApiError'
    this.statusCode = statusCode
  }

  public getMessage(): string {
    try {
      const parsed = JSON.parse(this.message)

      if (parsed?.message) {
        return parsed.message
      }
    } catch {
      // Not JSON???
    }

    return this.message
  }

  public getType(): string {
    return 'bad_request'
  }
}


// Token/params missing or malformed
export const INVALID_REQUEST_AUTH_REFRESH_RESPONSE = 'invalid_request'

// Token expired, revoked, or invalid
export const INVALID_TOKEN_AUTH_REFRESH_RESPONSE = 'invalid_token'

export class InvalidRequestApiError extends ApiError {
  public getType(): string {
    return INVALID_REQUEST_AUTH_REFRESH_RESPONSE
  }
}

export class InvalidTokenApiError extends ApiError {
  public getType(): string {
    return INVALID_TOKEN_AUTH_REFRESH_RESPONSE
  }
}